import { render, staticRenderFns } from "./IGB2BSectorCodeSelect.vue?vue&type=template&id=51358dac"
import script from "./IGB2BSectorCodeSelect.vue?vue&type=script&lang=js"
export * from "./IGB2BSectorCodeSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports